import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import AccountDropdown from '../shared/AccountDropdown';
import MobileMenuDropdown from './MobileMenuDropdown';

/**
 * Shared title row for dashboard bottom-nav tabs on mobile.
 * Connect broker CTAs live in page empty states — not the header — so titles stay readable.
 */
export default function DashboardMobileTabHeader({
  title = null,
  menuCurrentPage = 'dashboard',
  showAccountDropdown = false,
  /** Optional controls rendered to the left of the menu (e.g. Portfolio section tabs). */
  headerActions = null,
}) {
  const { colors } = useTheme();
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px',
        borderBottom: `1px solid ${colors.borderLight}`,
        gap: 8,
        flexShrink: 0,
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt=""
        role="presentation"
        onClick={() => navigate('/home')}
        style={{
          height: 40,
          width: 40,
          objectFit: 'contain',
          cursor: 'pointer',
          flexShrink: 0,
          borderRadius: 8,
        }}
      />
      {title ? (
        <h5
          style={{
            margin: 0,
            color: colors.text,
            fontSize: '1.1rem',
            fontWeight: 600,
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {title}
        </h5>
      ) : (
        <div style={{ flex: 1, minWidth: 0 }} />
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
        {headerActions}
        {showAccountDropdown ? (
          <AccountDropdown compact labelTailChars={5} sizeToContent />
        ) : null}
        <MobileMenuDropdown currentPage={menuCurrentPage} />
      </div>
    </div>
  );
}
